
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me",
      function () {
        return require("private-next-pages/me/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me"])
      });
    }
  